import script from "./SelfCertificationDetailsInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelfCertificationDetailsInput.vue?vue&type=script&setup=true&lang=ts"

import "./SelfCertificationDetailsInput.vue?vue&type=style&index=0&id=c57113da&lang=css"

const __exports__ = script;

export default __exports__